// TODO: improve, review and re-enable

import { hashKey } from '@tanstack/vue-query'
import { del, get, getMany, keys, set, update } from 'idb-keyval'

import dconsole from '@/plugins/debug_console'

import { experimental_createPersister, makePersisterStorageKey } from './createPersister'
import queryClient from './query_client.js'
import { cleanQueryKey } from './query_utils.ts'

function getMutationStorageKey({ queryKey, verb } = { queryKey: null, verb: null }) {
  return makePersisterStorageKey({ queryKey, verb, prefix: 'Mutation' })
}

const storage = {
  getItem(key) {
    dconsole.debug(`⬅ 📦 GET from query storage: ${key}`)
    return get(key)
    // return localStorage.getItem(key)
  },
  setItem(key, value) {
    dconsole.debug(`➡ 📦 SET to query storage: ${key}`)
    return set(key, value)
    // return localStorage.setItem(key, value)
  },
  removeItem(key) {
    dconsole.debug(`📦 DEL from query storage: ${key}`)
    return del(key)
    // return localStorage.removeItem(key)
  },
  // NOTE: bc get and set are async and non-atomic, there's a risk of race condition
  // when updating an item. Therefore we need to use update instead of set:
  updateItem(key, fn) {
    dconsole.debug(`🔄 📦 UPDATE in query storage: ${key}`)
    return update(key, fn)
  },
  getKeys() {
    return keys()
  },
}

const persister = experimental_createPersister({ storage })

/*
███████ ████████  ██████  ██████   █████   ██████  ███████
██         ██    ██    ██ ██   ██ ██   ██ ██       ██
███████    ██    ██    ██ ██████  ███████ ██   ███ █████
     ██    ██    ██    ██ ██   ██ ██   ██ ██    ██ ██
███████    ██     ██████  ██   ██ ██   ██  ██████  ███████
*/

async function storeMutationsOnMutate({ verb: _verb, queryKey, data: _data }) {
  queryKey = cleanQueryKey(queryKey)

  // TODO: do we want to optimistically update the cache (again)?
  // -> call defaultOnMutate?

  await queryClient.cancelQueries({ queryKey })
}

// this needs to be called with a mutateAsync function from useMutation
// upon first load or when online status changes
async function submitStoredMutations(mutateAsync) {
  const prefix = getMutationStorageKey()

  const keys = await storage.getKeys().then(ks => ks.filter(k => k.startsWith(prefix)))
  if (keys.length === 0) {
    dconsole.debug('🧟 submitStoredMutations: No mutations to submit')
    return
  }

  const storedMutations = await getMany(keys)
  dconsole.debug(
    `🧟 submitStoredMutations found ${keys.length} keys, retrieved ${storedMutations.length} stored mutations`,
  )

  storedMutations.forEach(async (storedMutation) => {
    const { mutationKey, verb, data } = JSON.parse(storedMutation)
    // TODO:discard if TOO OLD
    // TODO: do we want to stop related GET queries?
    dconsole.debug(`🧟 submitStoredMutations: submitting ${hashKey(mutationKey)}`)
    await mutateAsync({ verb, queryKey: mutationKey, data })
  })
}

/*
 ██████  ███████ ███████ ██      ██ ███    ██ ███████
██    ██ ██      ██      ██      ██ ████   ██ ██
██    ██ █████   █████   ██      ██ ██ ██  ██ █████
██    ██ ██      ██      ██      ██ ██  ██ ██ ██
 ██████  ██      ██      ███████ ██ ██   ████ ███████

*/

// const isTransientError = (error) => {
//     return error?.response?.status === undefined || error?.response?.status == 502
// }

async function offlineMutationFn() {
  /*
    // NOTE: unless mutation is declared with networkMode: 'always', defaultMutationFn will
    //  not even be called in offline mode, but instead auto-retried later
    if (!onlineManager.isOnline()) {
        dconsole.debug('🧟 defaultMutationFn: offline mode')
        throw new Error('Offline')
    }

    return defaultMutationFn({ verb, queryKey, data, axiosOptions })
    */
}

async function offlineMutationOnMutate() {
  /*
    queryKey = cleanQueryKey(queryKey)

    // For PATCH/PUT (valuation requests)
    if (['PATCH', 'PUT'].includes(verb)) {
        await defaultOnMutate({ verb, queryKey, data, mergeOptions })

        // NOTE: in local storage we need to update:
        // 1. the mutation itself (create/update)
        // 2. the GET query

        var storageKey = getMutationStorageKey({ queryKey, verb })
        // NOTE: use updateItem instead of get/setItem to avoid race conditions
        storage.updateItem(storageKey, (storedData) => {
            if (storedData) storedData = JSON.parse(storedData)
            if (!storedData?.state) {
                storedData = {
                    mutationKey: queryKey,
                    data: {},
                    verb: verb,
                }
            }
            storedData.data = deepmerge(storedData.data, data, mergeOptions)
            return JSON.stringify(storedData)
        })

        // NOTE: the following ensures that persisted data is updated (not just the cache)
        // so that we can reload multiple times (while offline) and have the latest data
        // TODO: see if we can instead make the persister update from cache (might need to fake a succesful mutation)
        // TODO: we might need to tweak other aspects of the persister's data (such as dates):
        storageKey = makePersisterStorageKey(queryKey)

        // NOTE: use updateItem instead of get/setItem to avoid race conditions
        storage.updateItem(storageKey, (storedData) => {
            if (!storedData) return
            storedData = JSON.parse(storedData)
            if (!storedData.state?.data) return

            storedData.state.data = deepmerge(storedData.state.data, data, mergeOptions)
            return JSON.stringify(storedData)
            // return storedData
        })
    } else if (['POST', 'DELETE'].includes(verb)) {
        // For POST/DELETE (documents)

        // TODO: store in local storage
        // var storageKey = makeStorageKey(verb, queryKey)
        // storage.setItem(storageKey, JSON.stringify({ mutationKey: queryKey, data, verb }))

        // NOTE: we need to pass on the context for the onSuccess function (hence return):
        return crudOnMutate({
            verb,
            queryKey,
            data,
            mergeOptions,
            idFieldName: 'document_ref',
        })
    }
    */
}

async function offlineMutationOnSettled(_result) {
  /*
    queryKey = cleanQueryKey(queryKey)

    dconsole.debug(
        `🧟 offline-enabled Mutation onSettled: ${hashKey(queryKey)} | Error: ${
            error?.response?.status
        } - ${error}`
    )

    // Return (without removing local storage) if:
    // - we get an HTTP error indicating a transient server issue (502?)
    // - we are offline (no HTTP error)
    if (error && isTransientError(error)) return

    // Clean up: remove stored mutation from local storage
    queryKey = cleanQueryKey(queryKey)

    dconsole.debug(
        `🧟 offline-enabled Mutation onSettled cleaning local storage for | ${verb} | ${hashKey(queryKey)}`
    )
    storage.removeItem(getMutationStorageKey({ queryKey, verb }))
    dconsole.debug(`🧟 offline-enabled Mutation onSettled: refetching queries ${hashKey(queryKey)}`)

    // NOTE: now handling GET cache update in onSuccess:
    */
}

async function offlineMutationOnError() {
  /*
    queryKey = cleanQueryKey(queryKey)

    dconsole.debug(
        `🧟 offline-enabled Mutation onError | ${verb} | ${hashKey(queryKey)} (should be offline): ${error}`
    )

    // Do NOT rollback optimistic update if we are offline
    if (isTransientError(error)) return

    if (['PATCH', 'PUT'].includes(verb)) {
        // Clean up optimistic update of valuation requests:
        await optimisticOnError(error, { verb, queryKey })
    } else if (verb == 'POST') {
        // Clean up optimistic update of documents:
        await crudOnError(error, { verb, queryKey })
    }
    // TODO: do we need this (possibly redundant with above):
    return queryClient.refetchQueries({ queryKey: queryKey, type: 'active' })
    // TODO: do we need to explicitly clean the persisted storage or will the above take care of it?
    */
}

async function offlineMutationOnSuccess() {
  /*
    // For POST (documents): update the cache with the returned data:
    if (verb == 'POST') {
        // document POST will return a list instead of an object, unpack it
        if (data.length > 0) data = data[0]
        // remove params from queryKey (if any) to get the list queryKey
        const listQueryKey = getListQueryKey(queryKey)

        // TODO: handle multiple documents in a single POST?
        await crudOnSuccess(
            data,
            {
                verb,
                queryKey: listQueryKey,
                forceRefetch,
                mergeOptions,
                idFieldName: idFieldName ?? 'document_ref',
            },
            context
        )
    } else if (['PATCH', 'PUT'].includes(verb)) {
        await defaultOnSuccess(data, { ...options, verb, queryKey, refreshQueryKey: queryKey, forceRefetch })
    }
        */
}

export {
  offlineMutationFn,
  offlineMutationOnError,
  offlineMutationOnMutate,
  offlineMutationOnSettled,
  offlineMutationOnSuccess,
  persister,
  storeMutationsOnMutate,
  submitStoredMutations,
}
